import { component } from 'picoapp'
import $ from 'quantdom'
export default component((node) => {
  // Selecting component elements
  const scrollTrack = $(node).find(`[data-slider-animated-track]`).el()
  const prevBtn = $(node).find(`[data-slider-animated-prev-btn]`)
  const nextBtn = $(node).find(`[data-slider-animated-next-btn]`)

  const sliderAnimationInterval = +scrollTrack.dataset.sliderAnimationInterval * 1000

  const countSlides = scrollTrack.querySelectorAll('[data-slider-animated-slide]').length

  if (countSlides > 1) {
    prevBtn.el().style.display = 'block'
    nextBtn.el().style.display = 'block'
  }

  // Set the default active slide index
  const defaultActiveSlideIndex = 0

  // Set last slide index
  const lastSlideIndex = +scrollTrack.lastElementChild.dataset.sliderAnimatedSlideIndex

  // Flag to track if the slider is currently animating
  let isAnimating = false

  // Set an interval to automatically update the active slide every 5 seconds
  if (countSlides > 1) {
    setInterval(() => {
      if (!isAnimating) {
        updateActiveSlide()
      }
    }, sliderAnimationInterval)
  }

  // Attach click event listener to the previous button
  prevBtn.on('click', () => {
    if (!isAnimating) {
      updateActiveSlide(true)
    }
  })

  // Attach click event listener to the next button
  nextBtn.on('click', () => {
    if (!isAnimating) {
      updateActiveSlide()
    }
  })

  /**
   * Function to update the active slide
   * @param {boolean} moveToPrevSlide - Whether to move to the previous slide (default is false, moving to the next slide)
   */
  function updateActiveSlide(moveToPrevSlide = false) {
    // Find the currently active slide
    const prevActiveSlide = scrollTrack.querySelector(`[data-slider-animated-slide-active="true"]`)

    // Get the index of the currently active slide
    const prevActiveSlideIndex = parseInt(prevActiveSlide.dataset.sliderAnimatedSlideIndex)

    // Determine the new active slide index
    let newActiveSlideIndex = moveToPrevSlide ? prevActiveSlideIndex - 1 : prevActiveSlideIndex + 1

    // Reset the index if it exceeds the bounds
    if (newActiveSlideIndex >= scrollTrack.children.length) {
      newActiveSlideIndex = defaultActiveSlideIndex
    }

    // Go to the last element to have the "infinite" effect
    if (newActiveSlideIndex < 0) {
      newActiveSlideIndex = lastSlideIndex
    }

    // Find the new active slide based on the calculated index
    const newActiveSlide = scrollTrack.querySelector(`[data-slider-animated-slide-index="${newActiveSlideIndex}"]`)

    // Set the animating flag to true to prevent simultaneous animations
    isAnimating = true

    // Update the data attributes to reflect the new active slide
    prevActiveSlide.dataset.sliderAnimatedSlideActive = false
    newActiveSlide.dataset.sliderAnimatedSlideActive = true

    // Reset the animating flag after a delay (Must be equal to the CSS transition duration)
    setTimeout(() => {
      isAnimating = false
    }, 500)
  }
})
